module.exports = __webpack_public_path__ + "static/media/6.1c44e98a.png";